var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceVisionOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 22,
    viewBox: "0 0 41 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1153 2.76857C31.8179 0.0298784 23.869 0.0125725 20.8725 0.00391949C20.6347 0.00391949 20.4284 0.00391949 20.2669 0.00391949C19.8048 -0.00473357 8.95813 -0.160489 4.38708 2.75992C4.17176 2.88971 -0.91516 6.0178 0.488902 13.6109C0.892626 15.7828 1.87053 17.7211 3.32394 19.2094C4.39157 20.304 5.60722 21.0741 6.93951 21.5024C7.07409 21.55 7.67519 21.7577 8.57235 21.8918C9.0613 21.9654 9.55475 22 10.0482 22C12.2104 22 14.377 21.3164 16.1534 20.0444L17.3556 19.1834C17.8715 18.8157 18.4232 18.4869 19.0109 18.197C19.7824 17.8162 20.7065 17.8162 21.496 18.2056C22.0702 18.4869 22.6175 18.8157 23.1333 19.1834L24.3355 20.0444C26.5201 21.6063 29.2834 22.2812 31.9166 21.8918C32.8137 21.7577 33.4148 21.55 33.5494 21.5024C34.8817 21.0741 36.0973 20.304 37.165 19.2094C38.6184 17.7211 39.6008 15.7828 40 13.6109C41.3816 6.13029 36.1153 2.76857 36.1153 2.76857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceVisionOs);
export default __webpack_public_path__ + "static/media/device_visionOS.ee13a0440adfe35de425c620bea70880.svg";
export { ForwardRef as ReactComponent };